import { getStreetName } from './getStreetName';

const formatText = (text, prefix) => {
  if (!text?.trim()) {
    return '';
  }

  return prefix ? `${prefix.trim()} ${text.trim()}` : text.trim();
};

const joinTexts = (texts, separator) =>
  texts.filter((text) => text?.trim()).join(separator);

export const generateAddress = (house, flat) => {
  if (!house) {
    return '';
  }

  const { building, corpus, streetName } = house;

  const buildingText = formatText(building, 'д.');
  const corpusText = formatText(corpus, 'к.');


  const { name, typeName, synonym } = flat || {};

  const typeNameText = typeName?.trim()?.toLowerCase() || '';
  const nameText = name?.trim() || '';
  const synonimText = synonym ? `(${synonym.trim()})` : '';

  const flatText = joinTexts([typeNameText, nameText, synonimText], ' ');

  const streetNameText = getStreetName(streetName.trim());

  return joinTexts([streetNameText, buildingText, corpusText, flatText], ', ');
};
